var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
var CustomJsonContext = createContext(null);
export var CustomJsonProvider = function (_a) {
    var _b = _a.customJson, customJson = _b === void 0 ? {} : _b, _c = _a.getCustomJson, getCustomJson = _c === void 0 ? function () { return ({}); } : _c, children = _a.children;
    return (_jsx(CustomJsonContext.Provider, __assign({ value: {
            customJson: customJson,
            getCustomJson: getCustomJson,
        } }, { children: children })));
};
export var useCustomJson = function () {
    var context = useContext(CustomJsonContext);
    if (!context)
        throw new Error('CustomJsonProvider not found in root');
    return context;
};
//# sourceMappingURL=CustomJson.js.map